// @ts-nocheck
// get all contracts
export const GET_ALL_CONTRACTS_REQUEST = "GET_ALL_CONTRACTS_REQUEST";
export const GET_ALL_CONTRACTS_SUCCESS = "GET_ALL_CONTRACTS_SUCCESS";
export const GET_ALL_CONTRACTS_FAILURE = "GET_ALL_CONTRACTS_FAILURE";

// discard contracts
export const DISCARD_CONTRACT_REQUEST = "DISCARD_CONTRACT_REQUEST";
export const DISCARD_CONTRACT_SUCCESS = "DISCARD_CONTRACT_SUCCESS";
export const DISCARD_CONTRACT_FAILURE = "DISCARD_CONTRACT_FAILURE";

// (receiver's end have to show as cards)
// new contracts
export const GET_ALL_NEW_CONTRACTS_REQUEST = "GET_ALL_NEW_CONTRACTS_REQUEST";
export const GET_ALL_NEW_CONTRACTS_SUCCESS = "GET_ALL_NEW_CONTRACTS_SUCCESS";
export const GET_ALL_NEW_CONTRACTS_FAILURE = "GET_ALL_NEW_CONTRACTS_FAILURE";

// under review contracts
export const GET_UNDER_REVIEW_CONTRACTS_REQUEST =
  "GET_UNDER_REVIEW_CONTRACTS_REQUEST";
export const GET_UNDER_REVIEW_CONTRACTS_SUCCESS =
  "GET_UNDER_REVIEW_CONTRACTS_SUCCESS";
export const GET_UNDER_REVIEW_CONTRACTS_FAILURE =
  "GET_UNDER_REVIEW_CONTRACTS_FAILURE";

// verified contracts
export const GET_ALL_VERIFIED_CONTRACTS_REQUEST =
  "GET_ALL_VERIFIED_CONTRACTS_REQUEST";
export const GET_ALL_VERIFIED_CONTRACTS_SUCCESS =
  "GET_ALL_VERIFIED_CONTRACTS_SUCCESS";
export const GET_ALL_VERIFIED_CONTRACTS_FAILURE =
  "GET_ALL_VERIFIED_CONTRACTS_FAILURE";

// fetch contract details
export const FETCH_CONTRACT_DETAILS_REQUEST = "FETCH_CONTRACT_DETAILS_REQUEST";
export const FETCH_CONTRACT_DETAILS_SUCCESS = "FETCH_CONTRACT_DETAILS_SUCCESS";
export const FETCH_CONTRACT_DETAILS_FAILURE = "FETCH_CONTRACT_DETAILS_FAILURE";

// approve contract
export const APPROVE_CONTRACT_REQUEST = "APPROVE_CONTRACT_REQUEST";
export const APPROVE_CONTRACT_SUCCESS = "APPROVE_CONTRACT_SUCCESS";
export const APPROVE_CONTRACT_FAILURE = "APPROVE_CONTRACT_FAILURE";

// attach file to contract
export const ATTACH_FILE_TO_CONTRACT_REQUEST =
  "ATTACH_FILE_TO_CONTRACT_REQUEST";
export const ATTACH_FILE_TO_CONTRACT_SUCCESS =
  "ATTACH_FILE_TO_CONTRACT_SUCCESS";
export const ATTACH_FILE_TO_CONTRACT_FAILURE =
  "ATTACH_FILE_TO_CONTRACT_FAILURE";

// attach PDF to contract
export const ATTACH_PDF_TO_CONTRACT_REQUEST = "ATTACH_PDF_TO_CONTRACT_REQUEST";
export const ATTACH_PDF_TO_CONTRACT_SUCCESS = "ATTACH_PDF_TO_CONTRACT_SUCCESS";
export const ATTACH_PDF_TO_CONTRACT_FAILURE = "ATTACH_PDF_TO_CONTRACT_FAILURE";

// add new contract
export const ADD_NEW_CONTRACT_REQUEST = "ADD_NEW_CONTRACT_REQUEST";
export const ADD_NEW_CONTRACT_SUCCESS = "ADD_NEW_CONTRACT_SUCCESS";
export const ADD_NEW_CONTRACT_FAILURE = "ADD_NEW_CONTRACT_FAILURE";

// edit contract
export const EDIT_CONTRACT_REQUEST = "EDIT_CONTRACT_REQUEST";
export const EDIT_CONTRACT_SUCCESS = "EDIT_CONTRACT_SUCCESS";
export const EDIT_CONTRACT_FAILURE = "EDIT_CONTRACT_FAILURE";

// verify contact
export const VERIFY_CONTRACT_REQUEST = "VERIFY_CONTRACT_REQUEST";
export const VERIFY_CONTRACT_SUCCESS = "VERIFY_CONTRACT_SUCCESS";
export const VERIFY_CONTRACT_FAILURE = "VERIFY_CONTRACT_FAILURE";

// add signature to contract
export const ADD_SIGNATURE_TO_CONTRACT_REQUEST =
  "ADD_SIGNATURE_TO_CONTRACT_REQUEST";
export const ADD_SIGNATURE_TO_CONTRACT_SUCCESS =
  "ADD_SIGNATURE_TO_CONTRACT_SUCCESS";
export const ADD_SIGNATURE_TO_CONTRACT_FAILURE =
  "ADD_SIGNATURE_TO_CONTRACT_FAILURE";

// add signature
export const ADD_SIGNATURE_REQUEST = "ADD_SIGNATURE_REQUEST";
export const ADD_SIGNATURE_SUCCESS = "ADD_SIGNATURE_SUCCESS";
export const ADD_SIGNATURE_FAILURE = "ADD_SIGNATURE_FAILURE";

// edit signature
export const EDIT_SIGNATURE_REQUEST = "EDIT_SIGNATURE_REQUEST";
export const EDIT_SIGNATURE_SUCCESS = "EDIT_SIGNATURE_SUCCESS";
export const EDIT_SIGNATURE_FAILURE = "EDIT_SIGNATURE_FAILURE";

// delete signature
export const DELETE_SIGNATURE_REQUEST = "DELETE_SIGNATURE_REQUEST";
export const DELETE_SIGNATURE_SUCCESS = "DELETE_SIGNATURE_SUCCESS";
export const DELETE_SIGNATURE_FAILURE = "DELETE_SIGNATURE_FAILURE";

// get signatures
export const GET_SIGNATURE_REQUEST = "GET_SIGNATURE_REQUEST";
export const GET_SIGNATURE_SUCCESS = "GET_SIGNATURE_SUCCESS";
export const GET_SIGNATURE_FAILURE = "GET_SIGNATURE_FAILURE";

// update contarct status
export const UPDATE_CONTRACT_STATUS_REQUEST = "UPDATE_CONTRACT_STATUS_REQUEST";
export const UPDATE_CONTRACT_STATUS_SUCCESS = "UPDATE_CONTRACT_STATUS_SUCCESS";
export const UPDATE_CONTRACT_STATUS_FAILURE = "UPDATE_CONTRACT_STATUS_FAILURE";